import { TYPE, SPACING } from '../../lib/design-tokens';

/**
 * PageKpiStrip — KPI-rij onder de toolbar
 * STANDAARD: label=12px, value=24px, sub=12px, gap=24px
 */
export const PageKpiStrip = ({ items, testId = 'kpi' }) => (
  <div className={`${SPACING.pagePx} ${SPACING.pagePy} border-b border-neutral-100 bg-white`} data-testid={`${testId}-strip`}>
    <div className={`grid grid-cols-2 sm:grid-cols-${Math.min(items.length, 5)} ${SPACING.kpiGap}`}>
      {items.map((kpi, i) => (
        <div key={i} className="flex flex-col" data-testid={`${testId}-${i}`}>
          <span className={TYPE.kpiLabel}>{kpi.label}</span>
          <span className={`${TYPE.kpiValue} ${kpi.color || 'text-neutral-800'} mt-1`}>{kpi.value}</span>
          {kpi.sub && <span className={`${TYPE.kpiSub} mt-0.5`}>{kpi.sub}</span>}
        </div>
      ))}
    </div>
  </div>
);
